import { createSelector } from "../../../utils/createSelector.js";
export const gridColumnResizeSelector = state => state.columnResize;
export const gridResizingColumnFieldSelector = createSelector(gridColumnResizeSelector, columnResize => columnResize.resizingColumnField);